/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CostReimbursementByPharmacist
// ====================================================

export interface CostReimbursementByPharmacist_costReimbursementByPharmacist_order_forms {
  /**
   * 환자 이름
   */
  patientName: string;
}

export interface CostReimbursementByPharmacist_costReimbursementByPharmacist_order {
  /**
   * 주문 ID (order.id)
   */
  orderId: string;
  /**
   * 외부 노출 주문 ID
   */
  orderExternalId: string;
  /**
   * 진료 신청서 조회
   */
  forms: CostReimbursementByPharmacist_costReimbursementByPharmacist_order_forms[];
}

export interface CostReimbursementByPharmacist_costReimbursementByPharmacist {
  /**
   * 정산 금액
   */
  amount: number;
  /**
   * 카드 수수료
   */
  fee: number;
  /**
   * 보전인 경우, 카드 수수료가 차감된 정산 금액
   */
  calculatedAmount: number;
  /**
   * 보전 항목 ID
   */
  costReimbursementId: string;
  /**
   * 보전인지 차감인지 여부 (REIMBURSEMENT | DEDUCTION)
   */
  costReimbursementType: CostReimbursementType;
  /**
   * 변동 발생일시
   */
  createdAt: any;
  /**
   * 주문 ID
   */
  orderId: string;
  /**
   * 변동 사유
   */
  reason: CostReimbursementReason;
  /**
   * 귀책 주체
   */
  responsibility: CostReimbursementResponsibility;
  /**
   * 마지막 수정일시
   */
  updatedAt: any | null;
  /**
   * 주문 상세 정보
   */
  order: CostReimbursementByPharmacist_costReimbursementByPharmacist_order;
}

export interface CostReimbursementByPharmacist {
  /**
   * 약사 웹 비용 변동 항목 리스트
   */
  costReimbursementByPharmacist: CostReimbursementByPharmacist_costReimbursementByPharmacist[];
}

export interface CostReimbursementByPharmacistVariables {
  request: PharmacyCostReimbursementRequestInput;
  paginationCriteria: PaginationCriteriaInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CostReimbursementSummaryByPharmacist
// ====================================================

export interface CostReimbursementSummaryByPharmacist_costReimbursementSummaryByPharmacist {
  /**
   * 변동비용 총합
   */
  reimbursementSum: number;
  /**
   * 변동비용 총 건 수
   */
  count: number;
}

export interface CostReimbursementSummaryByPharmacist {
  /**
   * 약사 웹 비용 변동 항목 요약
   */
  costReimbursementSummaryByPharmacist: CostReimbursementSummaryByPharmacist_costReimbursementSummaryByPharmacist | null;
}

export interface CostReimbursementSummaryByPharmacistVariables {
  request: PharmacyCostReimbursementSummaryRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ShippingLabelByPharmacist
// ====================================================

export interface ShippingLabelByPharmacist_shippingLabel_receiver_address {
  /**
   * 상세주소
   */
  detailAddress: string | null;
  /**
   * 지번주소
   */
  jibunAddress: string;
  /**
   * 도로명주소
   */
  roadAddress: string | null;
}

export interface ShippingLabelByPharmacist_shippingLabel_receiver {
  /**
   * 주소
   */
  address: ShippingLabelByPharmacist_shippingLabel_receiver_address;
  /**
   * 이름
   */
  name: string;
  /**
   * 핸드폰번호
   */
  phone: string;
}

export interface ShippingLabelByPharmacist_shippingLabel_sender_address {
  /**
   * 상세주소
   */
  detailAddress: string | null;
  /**
   * 지번주소
   */
  jibunAddress: string;
  /**
   * 도로명주소
   */
  roadAddress: string | null;
}

export interface ShippingLabelByPharmacist_shippingLabel_sender {
  /**
   * 주소
   */
  address: ShippingLabelByPharmacist_shippingLabel_sender_address;
  /**
   * 이름
   */
  name: string;
  /**
   * 핸드폰번호
   */
  phone: string;
}

export interface ShippingLabelByPharmacist_shippingLabel {
  /**
   * 업체별로 관리하는 주문번호, 송장번호와 다르거나 없을 수 있음
   */
  agencyOrderNumber: string | null;
  /**
   * 권역코드
   */
  areaGroupCode: string;
  /**
   * 배송 메모
   */
  deliveryMemo: string | null;
  /**
   * 배송종류, 업체별로 명칭이 다름
   */
  deliveryType: string;
  /**
   * 허브명
   */
  hubName: string | null;
  /**
   * 주문번호
   */
  orderNumber: string;
  /**
   * 받는 사람
   */
  receiver: ShippingLabelByPharmacist_shippingLabel_receiver;
  /**
   * 보내는 사람
   */
  sender: ShippingLabelByPharmacist_shippingLabel_sender;
  /**
   * 송장번호
   */
  trackingNumber: string;
  /**
   * 배송사별 추가 정보
   */
  additionalInformation: string;
}

export interface ShippingLabelByPharmacist {
  /**
   * 송장 출력에 필요한 데이터 조회
   */
  shippingLabel: ShippingLabelByPharmacist_shippingLabel | null;
}

export interface ShippingLabelByPharmacistVariables {
  shippingLabelRequest: ShippingLabelRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeliveryReceipt
// ====================================================

export interface DeliveryReceipt_deliveryReceipt_receiver_address {
  /**
   * 상세주소
   */
  detailAddress: string | null;
  /**
   * 지번주소
   */
  jibunAddress: string;
  /**
   * 도로명주소
   */
  roadAddress: string | null;
}

export interface DeliveryReceipt_deliveryReceipt_receiver {
  /**
   * 주소
   */
  address: DeliveryReceipt_deliveryReceipt_receiver_address;
  /**
   * 이름
   */
  name: string;
  /**
   * 핸드폰번호
   */
  phone: string;
}

export interface DeliveryReceipt_deliveryReceipt_sender_address {
  /**
   * 상세주소
   */
  detailAddress: string | null;
  /**
   * 지번주소
   */
  jibunAddress: string;
  /**
   * 도로명주소
   */
  roadAddress: string | null;
}

export interface DeliveryReceipt_deliveryReceipt_sender {
  /**
   * 주소
   */
  address: DeliveryReceipt_deliveryReceipt_sender_address;
  /**
   * 이름
   */
  name: string;
  /**
   * 핸드폰번호
   */
  phone: string;
}

export interface DeliveryReceipt_deliveryReceipt {
  /**
   * 업체별로 관리하는 주문번호, 송장번호와 다르거나 없을 수 있음
   */
  agencyOrderNumber: string | null;
  /**
   * 권역코드
   */
  areaGroupCode: string;
  /**
   * 배송 메모
   */
  deliveryMemo: string | null;
  /**
   * 배송종류, 업체별로 명칭이 다름
   */
  deliveryType: string;
  /**
   * 허브명
   */
  hubName: string | null;
  /**
   * 주문번호
   */
  orderNumber: string;
  /**
   * 받는 사람
   */
  receiver: DeliveryReceipt_deliveryReceipt_receiver;
  /**
   * 보내는 사람
   */
  sender: DeliveryReceipt_deliveryReceipt_sender;
  /**
   * 송장번호
   */
  trackingNumber: string;
  /**
   * 배송사별 추가 정보
   */
  additionalInformation: string;
}

export interface DeliveryReceipt {
  /**
   * 배송 주문 접수
   */
  deliveryReceipt: DeliveryReceipt_deliveryReceipt | null;
}

export interface DeliveryReceiptVariables {
  deliveryReceiptRequest: DeliveryReceiptRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BePharmacyPresent
// ====================================================

export interface BePharmacyPresent {
  /**
   * 약국 부재중 아님(처방전 접수 받기)
   */
  bePharmacyPresent: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacyContactsInfomation
// ====================================================

export interface GetPharmacyContactsInfomation_getPharmacy_pharmacyContacts {
  /**
   * 연락처 id
   */
  id: string;
  /**
   * 핸드폰 번호
   */
  phone: string;
  /**
   * 별칭
   */
  contactAlias: string | null;
  /**
   * 활성화 여부
   */
  isActive: boolean;
}

export interface GetPharmacyContactsInfomation_getPharmacy_pharmacyDuties {
  /**
   * 영업시간 id
   */
  id: string;
  /**
   * 요일
   */
  weekDay: number;
  /**
   * 오픈 시각
   */
  openTime: string;
  /**
   * 마감 시각
   */
  closeTime: string;
  /**
   * 휴무일 여부
   */
  isClosed: boolean;
}

export interface GetPharmacyContactsInfomation_getPharmacy {
  /**
   * 부재중 여부
   */
  isAbsent: boolean;
  /**
   * 약국 연락처
   */
  pharmacyContacts: GetPharmacyContactsInfomation_getPharmacy_pharmacyContacts[];
  /**
   * 약국 영업시간
   */
  pharmacyDuties: GetPharmacyContactsInfomation_getPharmacy_pharmacyDuties[];
}

export interface GetPharmacyContactsInfomation {
  /**
   * 약국 상세 조회
   */
  getPharmacy: GetPharmacyContactsInfomation_getPharmacy | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacyDetail
// ====================================================

export interface GetPharmacyDetail_getPharmacy_pharmacist {
  /**
   * 약사 id
   */
  id: string;
  /**
   * 약사명
   */
  pharmacistName: string;
  /**
   * 핸드폰 번호
   */
  phone: string;
  /**
   * 은행명
   */
  bank: string | null;
  /**
   * 계좌번호
   */
  accountNumber: string | null;
  /**
   * 예금주명
   */
  accountName: string | null;
}

export interface GetPharmacyDetail_getPharmacy_accountInfo {
  /**
   * 계정명
   */
  username: string;
}

export interface GetPharmacyDetail_getPharmacy_pharmacyDuties {
  /**
   * 영업시간 id
   */
  id: string;
  /**
   * 요일
   */
  weekDay: number;
  /**
   * 오픈 시각
   */
  openTime: string;
  /**
   * 마감 시각
   */
  closeTime: string;
  /**
   * 휴무일 여부
   */
  isClosed: boolean;
}

export interface GetPharmacyDetail_getPharmacy {
  /**
   * 약국 id
   */
  id: string;
  /**
   * 약국명
   */
  name: string;
  /**
   * 도로명 주소
   */
  roadAddress: string | null;
  /**
   * 지번 주소
   */
  jibunAddress: string | null;
  /**
   * 상세 주소
   */
  detailAddress: string | null;
  /**
   * 팩스번호
   */
  faxNumber: string | null;
  /**
   * 전화번호
   */
  tel: string | null;
  /**
   * 제휴여부
   */
  partnerShip: PharmacyPartnerShip;
  /**
   * 약사
   */
  pharmacist: GetPharmacyDetail_getPharmacy_pharmacist | null;
  /**
   * 계정정보
   */
  accountInfo: GetPharmacyDetail_getPharmacy_accountInfo;
  /**
   * 약국 영업시간
   */
  pharmacyDuties: GetPharmacyDetail_getPharmacy_pharmacyDuties[];
}

export interface GetPharmacyDetail {
  /**
   * 약국 상세 조회
   */
  getPharmacy: GetPharmacyDetail_getPharmacy | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacistDevices
// ====================================================

export interface GetPharmacistDevices_getPharmacy_pharmacist_devices {
  /**
   * 기기 ID
   */
  id: string;
  /**
   * 약사 ID
   */
  pharmacistId: string;
  /**
   * 기기 별칭
   */
  alias: string;
  /**
   * 기기 고유ID
   */
  deviceId: string;
  /**
   * 푸시토큰
   */
  firebaseToken: string;
}

export interface GetPharmacistDevices_getPharmacy_pharmacist {
  /**
   * 약사 디바이스
   */
  devices: GetPharmacistDevices_getPharmacy_pharmacist_devices[];
}

export interface GetPharmacistDevices_getPharmacy {
  /**
   * 약사
   */
  pharmacist: GetPharmacistDevices_getPharmacy_pharmacist | null;
}

export interface GetPharmacistDevices {
  /**
   * 약국 상세 조회
   */
  getPharmacy: GetPharmacistDevices_getPharmacy | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDayOfWeek
// ====================================================

export interface GetDayOfWeek {
  /**
   * 요일 조회
   */
  dayOfWeek: DayOfWeekType | null;
}

export interface GetDayOfWeekVariables {
  date: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddPharmacistDevice
// ====================================================

export interface AddPharmacistDevice {
  /**
   * 약사 기기 추가
   */
  addPharmacistDevice: boolean;
}

export interface AddPharmacistDeviceVariables {
  request: PharmacistDeviceAddMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StartDelivery
// ====================================================

export interface StartDelivery {
  /**
   * 주문 배달 시작
   */
  startDelivery: boolean;
}

export interface StartDeliveryVariables {
  request: OrderDeliveryStartMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePharmacyContacts
// ====================================================

export interface UpdatePharmacyContacts {
  /**
   * 약국 연락처 추가, 수정
   */
  updatePharmacyContacts: boolean;
}

export interface UpdatePharmacyContactsVariables {
  request: PharmacyContactUpdateRequestInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BePharmacyAbsent
// ====================================================

export interface BePharmacyAbsent {
  /**
   * 약국 자리비움 상태로 변경
   */
  bePharmacyAbsent: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCommerceOrdersByRequestContext
// ====================================================

export interface GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext_orderItems_product {
  productThumbnailUrl: string;
}

export interface GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext_orderItems {
  /**
   * 상품 이름
   */
  name: string;
  /**
   * 주문 아이템 가격
   */
  price: number;
  /**
   * 상품 수량
   */
  quantity: number;
  /**
   * 상품 정보 (Deprecated)
   */
  product: GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext_orderItems_product;
}

export interface GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext {
  /**
   * 총 상품금액
   */
  totalItemPrice: number;
  /**
   * 결제완료 금액
   */
  paidAmount: number;
  /**
   * 오더 아이템 리스트
   */
  orderItems: GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext_orderItems[];
}

export interface GetCommerceOrdersByRequestContext {
  /**
   * 요청 컨텍스트로 커머스 주문 조회
   */
  getCommerceOrdersByRequestContext: GetCommerceOrdersByRequestContext_getCommerceOrdersByRequestContext[];
}

export interface GetCommerceOrdersByRequestContextVariables {
  requestContextRequest: DomainRequestContextRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ModifyPriceByPharmacist
// ====================================================

export interface ModifyPriceByPharmacist {
  /**
   * 약사의 주문 가격 재설정
   */
  modifyPriceByPharmacist: boolean;
}

export interface ModifyPriceByPharmacistVariables {
  request: OrderModifyPriceMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: OrderResetByPharmacist
// ====================================================

export interface OrderResetByPharmacist {
  /**
   * 약사의 주문 초기화
   */
  initByPharmacist: boolean;
}

export interface OrderResetByPharmacistVariables {
  request: InitOrderByPharmacistMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EmergencyMessageReason
// ====================================================

export interface EmergencyMessageReason_getEmergencyMessageReason {
  /**
   * 응답 문자 사유 id
   */
  id: string;
  /**
   * 응답 문자 사유
   */
  reason: string;
  /**
   * 응답 문자 사유 타입
   */
  type: EmergencyMessageReasonType;
  /**
   * 응답 문자 사유 정렬 순서
   */
  sortKey: number;
}

export interface EmergencyMessageReason {
  /**
   * 응급 문자 사유 조회
   */
  getEmergencyMessageReason: EmergencyMessageReason_getEmergencyMessageReason[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmergencyMessage
// ====================================================

export interface EmergencyMessage {
  /**
   * 응급 문자 전송
   */
  sendEmergencyMessage: boolean;
}

export interface EmergencyMessageVariables {
  request: SendEmergencyMessageRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SearchProductsByPharmacist
// ====================================================

export interface SearchProductsByPharmacist_searchProductsByPharmacist_category {
  categoryId: string;
  channelType: ChannelType;
}

export interface SearchProductsByPharmacist_searchProductsByPharmacist_meta {
  /**
   * 메타 정보 키 (PHARMACEUTICAL_COMPANY, ...)
   */
  key: string;
  /**
   * 메타 정보 값
   */
  value: string;
}

export interface SearchProductsByPharmacist_searchProductsByPharmacist {
  category: SearchProductsByPharmacist_searchProductsByPharmacist_category;
  meta: SearchProductsByPharmacist_searchProductsByPharmacist_meta[];
  name: string;
  price: number;
  productId: string;
}

export interface SearchProductsByPharmacist {
  /**
   * 약사의 상품 검색 (레거시)
   */
  searchProductsByPharmacist: SearchProductsByPharmacist_searchProductsByPharmacist[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetCompletePartnershipPickupOrder
// ====================================================

export interface SetCompletePartnershipPickupOrder {
  /**
   * 제휴약국 방문수령 주문 완료처리
   */
  completePartnershipPickupOrder: boolean;
}

export interface SetCompletePartnershipPickupOrderVariables {
  request: OrderPartnershipPickupCompleteMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBannerAdExchange
// ====================================================

export interface GetBannerAdExchange_getBannerAdExchange_clickAction {
  /**
   * 클릭시 취할 행동의 종류 (OUTLINK, PHONE_CALL, ...)
   */
  clickActionType: ClickActionType;
  /**
   * 클릭시 이동할 랜딩페이지의 링크
   */
  outlink: string | null;
}

export interface GetBannerAdExchange_getBannerAdExchange {
  /**
   * 배너 이미지 presigned URL
   */
  bannerImageUrl: string;
  /**
   * 배너 광고 ID
   */
  bannerAdId: string;
  /**
   * 클릭시 발생시킬 행동
   */
  clickAction: GetBannerAdExchange_getBannerAdExchange_clickAction;
  /**
   * 구좌가 배치될 구체적 위치
   */
  targetPlace: AdTargetPlace;
}

export interface GetBannerAdExchange {
  /**
   * 노출할 광고 소재 가져오기
   */
  getBannerAdExchange: GetBannerAdExchange_getBannerAdExchange | null;
}

export interface GetBannerAdExchangeVariables {
  request: BannerAdExchangeRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: HandleAdExposure
// ====================================================

export interface HandleAdExposure {
  /**
   * 광고 노출 처리
   */
  handleAdExposure: boolean;
}

export interface HandleAdExposureVariables {
  request: AdExposureHandleMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacyTreatmentMedicineStructures
// ====================================================

export interface GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines_pharmacyMedicines_pharmacyMedicineStandards {
  /**
   * 규격 ID
   */
  medicineStandardId: string;
  /**
   * 규격 정보
   */
  medicineStandard: string;
  /**
   * 입력 가능/활성화 여부
   */
  isActivated: boolean;
}

export interface GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines_pharmacyMedicines {
  medicineId: string;
  medicineName: string;
  insuranceCode: string;
  pharmacyMedicineStandards: GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines_pharmacyMedicines_pharmacyMedicineStandards[];
}

export interface GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines {
  treatmentId: string;
  treatmentName: string;
  pharmacyMedicines: GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines_pharmacyMedicines[];
}

export interface GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures {
  treatmentMedicines: GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures_treatmentMedicines[];
}

export interface GetPharmacyTreatmentMedicineStructures {
  /**
   * 약국 취급 가능 증상 약품 규격 구조 조회
   */
  pharmacyTreatmentMedicineStructures: GetPharmacyTreatmentMedicineStructures_pharmacyTreatmentMedicineStructures;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegisterPharmacyHandlingMedicines
// ====================================================

export interface RegisterPharmacyHandlingMedicines {
  /**
   * 약국 취급약품 등록
   */
  registerPharmacyHandlingMedicines: boolean;
}

export interface RegisterPharmacyHandlingMedicinesVariables {
  request: PharmacyHandlingMedicineRegisterMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertPharmacyHandlingMedicines
// ====================================================

export interface UpsertPharmacyHandlingMedicines {
  /**
   * 약국 취급약품 수정
   */
  upsertPharmacyHandlingMedicines: boolean;
}

export interface UpsertPharmacyHandlingMedicinesVariables {
  request: PharmacyHandlingMedicineUpsertMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacyHandlingMedicines
// ====================================================

export interface GetPharmacyHandlingMedicines_pharmacyHandlingMedicines_pharmacyHandlingMedicines_medicineStandardPrices {
  /**
   * 규격 ID
   */
  medicineStandardId: string;
  /**
   * 규격 정보
   */
  medicineStandard: string;
  /**
   * 금액
   */
  price: number;
  /**
   * 품절 여부
   */
  isSoldOut: boolean;
}

export interface GetPharmacyHandlingMedicines_pharmacyHandlingMedicines_pharmacyHandlingMedicines {
  /**
   * 약국 ID
   */
  pharmacyId: string;
  /**
   * 약품 ID
   */
  medicineId: string;
  /**
   * 약품명
   */
  medicineName: string;
  /**
   * 보험코드
   */
  insuranceCode: string;
  /**
   * 약품 규격별 가격 리스트
   */
  medicineStandardPrices: GetPharmacyHandlingMedicines_pharmacyHandlingMedicines_pharmacyHandlingMedicines_medicineStandardPrices[];
}

export interface GetPharmacyHandlingMedicines_pharmacyHandlingMedicines {
  totalCount: number;
  totalPageCount: number;
  pharmacyHandlingMedicines: GetPharmacyHandlingMedicines_pharmacyHandlingMedicines_pharmacyHandlingMedicines[];
}

export interface GetPharmacyHandlingMedicines {
  /**
   * 약국 취급약품 목록 조회
   */
  pharmacyHandlingMedicines: GetPharmacyHandlingMedicines_pharmacyHandlingMedicines;
}

export interface GetPharmacyHandlingMedicinesVariables {
  request: PagingRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPharmacyHandlingMedicine
// ====================================================

export interface GetPharmacyHandlingMedicine_pharmacyHandlingMedicine_medicineStandardPrices {
  /**
   * 규격 ID
   */
  medicineStandardId: string;
  /**
   * 규격 정보
   */
  medicineStandard: string;
  /**
   * 금액
   */
  price: number;
  /**
   * 품절 여부
   */
  isSoldOut: boolean;
}

export interface GetPharmacyHandlingMedicine_pharmacyHandlingMedicine {
  /**
   * 증상 ID
   */
  treatmentId: string;
  /**
   * 증상명
   */
  treatmentName: string;
  /**
   * 약국 ID
   */
  pharmacyId: string;
  /**
   * 약품 ID
   */
  medicineId: string;
  /**
   * 약품명
   */
  medicineName: string;
  /**
   * 보험코드
   */
  insuranceCode: string;
  /**
   * 약품 규격별 가격 리스트
   */
  medicineStandardPrices: GetPharmacyHandlingMedicine_pharmacyHandlingMedicine_medicineStandardPrices[];
}

export interface GetPharmacyHandlingMedicine {
  /**
   * 약국 취급약품 단일 조회
   */
  pharmacyHandlingMedicine: GetPharmacyHandlingMedicine_pharmacyHandlingMedicine;
}

export interface GetPharmacyHandlingMedicineVariables {
  request: PharmacyHandlingMedicineRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetMarkMedicineStandardAsSoldOut
// ====================================================

export interface SetMarkMedicineStandardAsSoldOut {
  /**
   * 약국 취급약품 규격 품절처리
   */
  markMedicineStandardAsSoldOut: boolean;
}

export interface SetMarkMedicineStandardAsSoldOutVariables {
  request: PharmacyHandlingMedicineStandardSoldOutMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetMarkMedicineStandardAsAvailable
// ====================================================

export interface SetMarkMedicineStandardAsAvailable {
  /**
   * 약국 취급약품 규격 품절 처리 해제
   */
  markMedicineStandardAsAvailable: boolean;
}

export interface SetMarkMedicineStandardAsAvailableVariables {
  request: PharmacyHandlingMedicineStandardSoldOutMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetOrderPrice
// ====================================================

export interface SetOrderPrice {
  /**
   * 주문 조제비 책정
   */
  setOrderPrice: boolean;
}

export interface SetOrderPriceVariables {
  request: OrderPricingMutationRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdTargetPlace {
  DOCTOR_WEB_SIDE_BIG_LEFT = "DOCTOR_WEB_SIDE_BIG_LEFT",
  DOCTOR_WEB_SIDE_BIG_RIGHT = "DOCTOR_WEB_SIDE_BIG_RIGHT",
  DOCTOR_WEB_SIDE_SMALL = "DOCTOR_WEB_SIDE_SMALL",
  PHARMACIST_WEB_SIDE_BIG = "PHARMACIST_WEB_SIDE_BIG",
  PHARMACIST_WEB_SIDE_SMALL = "PHARMACIST_WEB_SIDE_SMALL",
  USER_APP_COMMUNITY_ARTICLE_BOTTOM = "USER_APP_COMMUNITY_ARTICLE_BOTTOM",
  USER_APP_COMMUNITY_MAIN = "USER_APP_COMMUNITY_MAIN",
  USER_APP_DIAGNOSIS_HISTORY_IN_LIST = "USER_APP_DIAGNOSIS_HISTORY_IN_LIST",
  USER_APP_DOCTOR_LIST_DEPARTMENT_IN_LIST = "USER_APP_DOCTOR_LIST_DEPARTMENT_IN_LIST",
  USER_APP_DOCTOR_LIST_DEPARTMENT_TOP = "USER_APP_DOCTOR_LIST_DEPARTMENT_TOP",
  USER_APP_DOCTOR_LIST_TREATMENT_IN_LIST = "USER_APP_DOCTOR_LIST_TREATMENT_IN_LIST",
  USER_APP_DOCTOR_LIST_TREATMENT_TOP = "USER_APP_DOCTOR_LIST_TREATMENT_TOP",
  USER_APP_ENCYCLOPEDIA_DETAIL_BOTTOM = "USER_APP_ENCYCLOPEDIA_DETAIL_BOTTOM",
  USER_APP_EXIT = "USER_APP_EXIT",
  USER_APP_HEALTH_DOCUMENT = "USER_APP_HEALTH_DOCUMENT",
  USER_APP_HEALTH_MAIN = "USER_APP_HEALTH_MAIN",
  USER_APP_HOME_MAIN = "USER_APP_HOME_MAIN",
  USER_APP_HOSPITAL_SEARCH_DETAIL_BOTTOM = "USER_APP_HOSPITAL_SEARCH_DETAIL_BOTTOM",
  USER_APP_HOSPITAL_SEARCH_IN_LIST = "USER_APP_HOSPITAL_SEARCH_IN_LIST",
  USER_APP_MAGAZINE_ARTICLE_BOTTOM = "USER_APP_MAGAZINE_ARTICLE_BOTTOM",
  USER_APP_MAGAZINE_FAQ_BOTTOM = "USER_APP_MAGAZINE_FAQ_BOTTOM",
  USER_APP_POINT_MARKET_MAIN = "USER_APP_POINT_MARKET_MAIN",
  USER_APP_QNA_MAIN = "USER_APP_QNA_MAIN",
  USER_APP_QNA_QUESTION_BOTTOM = "USER_APP_QNA_QUESTION_BOTTOM",
  USER_APP_SEARCH_MAIN = "USER_APP_SEARCH_MAIN",
  USER_WEB_HOME_MAIN = "USER_WEB_HOME_MAIN",
  USER_WEB_SIDE_BIG_RIGHT = "USER_WEB_SIDE_BIG_RIGHT",
  USER_WEB_SIDE_SMALL_LEFT = "USER_WEB_SIDE_SMALL_LEFT",
  USER_WEB_SIDE_SMALL_RIGHT = "USER_WEB_SIDE_SMALL_RIGHT",
}

export enum ChannelType {
  PERSONALIZED_NUTRITION = "PERSONALIZED_NUTRITION",
  PHARMACY_ADDITIONAL_ORDER = "PHARMACY_ADDITIONAL_ORDER",
}

export enum ClickActionType {
  OUTLINK = "OUTLINK",
  PHONE_CALL = "PHONE_CALL",
}

export enum CostReimbursementReason {
  CANNOT_DELIVERY = "CANNOT_DELIVERY",
  DIAGNOSIS_COST = "DIAGNOSIS_COST",
  ETC = "ETC",
  EXTRA_DELIVERY = "EXTRA_DELIVERY",
  INCORRECT_PRESCRIPTION = "INCORRECT_PRESCRIPTION",
  MEDICINE_COST = "MEDICINE_COST",
  POST_SELF_DELIVERY = "POST_SELF_DELIVERY",
  QUICK_CANCEL_FEE = "QUICK_CANCEL_FEE",
  QUICK_SELF_DELIVERY = "QUICK_SELF_DELIVERY",
  REFUSAL_OF_DISPENSING = "REFUSAL_OF_DISPENSING",
  SEPARATE_PAYMENT = "SEPARATE_PAYMENT",
}

export enum CostReimbursementResponsibility {
  DELIVERY_AGENCY = "DELIVERY_AGENCY",
  ETC = "ETC",
  HOSPITAL = "HOSPITAL",
  PHARMACY = "PHARMACY",
  UNCLEAR = "UNCLEAR",
}

export enum CostReimbursementType {
  DEDUCTION = "DEDUCTION",
  REIMBURSEMENT = "REIMBURSEMENT",
}

export enum DayOfWeekType {
  FRIDAY = "FRIDAY",
  HOLIDAY = "HOLIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum DomainName {
  COMMERCE = "COMMERCE",
  COUNSELING = "COUNSELING",
  CS = "CS",
  HEALTHCARE = "HEALTHCARE",
  HOSPITAL = "HOSPITAL",
  PAYMENT = "PAYMENT",
  PHARMACY = "PHARMACY",
  SETTLEMENT = "SETTLEMENT",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export enum EmergencyMessageReasonType {
  DIRECT_INPUT = "DIRECT_INPUT",
  SELECT = "SELECT",
}

export enum PharmacyPartnerShip {
  nonpartnership = "nonpartnership",
  partnership = "partnership",
  pending = "pending",
}

export enum ShippingCompany {
  BAROGO = "BAROGO",
  BAROGO_TODAY = "BAROGO_TODAY",
  CJ = "CJ",
  DOOBAL = "DOOBAL",
  INSUNG_QUICK = "INSUNG_QUICK",
  KAKAO_DOBO = "KAKAO_DOBO",
  KAKAO_QUICK = "KAKAO_QUICK",
  LOGIALL = "LOGIALL",
  LOGISPOT = "LOGISPOT",
  MANUAL_QUICK = "MANUAL_QUICK",
  PICKUP = "PICKUP",
  POST_OFFICE = "POST_OFFICE",
  TEAM_FRESH = "TEAM_FRESH",
  TODAYPICKUP = "TODAYPICKUP",
  VROONG = "VROONG",
  VROONG_DAWN = "VROONG_DAWN",
}

export enum SortType {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * 광고 노출 처리 요청
 */
export interface AdExposureHandleMutationRequestInput {
  adId: string;
  adViewerOsPlatform?: string | null;
  exposedAt: any;
}

/**
 * 배너 광고 Ad Exchange 요청
 */
export interface BannerAdExchangeRequestInput {
  targetPlace: AdTargetPlace;
}

/**
 * 배송 주문 접수 요청
 */
export interface DeliveryReceiptRequestInput {
  orderNumber: string;
  shippingCompany: ShippingCompany;
}

export interface DomainRequestContextRequestInput {
  domain: DomainName;
  key: string;
}

/**
 * 주문 초기화 요청
 */
export interface InitOrderByPharmacistMutationRequestInput {
  orderId: string;
  reason: string;
}

/**
 * 주문 배달 시작 요청
 */
export interface OrderDeliveryStartMutationRequestInput {
  orderId: string;
}

/**
 * 주문 조제비 재설정
 */
export interface OrderModifyPriceMutationRequestInput {
  orderId: string;
  price: string;
  reason: string;
}

/**
 * 제휴약국 방문수령 주문 완료 요청
 */
export interface OrderPartnershipPickupCompleteMutationRequestInput {
  orderId: string;
}

/**
 * 주문 조제비 책정 요청
 */
export interface OrderPricingMutationRequestInput {
  alternativeLog?: string | null;
  alternativeReason?: string | null;
  orderId: string;
  price: number;
  useAlternative: boolean;
}

export interface PaginationCriteriaInput {
  pivotId?: number | null;
  size: number;
  sort: SortType;
}

export interface PagingRequestInput {
  limit?: number | null;
  page?: number | null;
}

export interface PharmacistDeviceAddMutationRequestInput {
  alias: string;
  deviceId: string;
  firebaseToken: string;
}

/**
 * 약국 연락처 추가, 수정 요청
 */
export interface PharmacyContactUpdateRequestInput {
  contactAlias: string;
  isActive?: boolean | null;
  phone: string;
}

/**
 * 약국 변동비용 조회 요청
 */
export interface PharmacyCostReimbursementRequestInput {
  costReimbursementType?: CostReimbursementType | null;
  createdAtFrom?: string | null;
  createdAtTo?: string | null;
  orderIds?: string[] | null;
  responsibility?: CostReimbursementResponsibility | null;
  updatedAtFrom?: string | null;
  updatedAtTo?: string | null;
}

/**
 * 약국 변동비용 조회 요청
 */
export interface PharmacyCostReimbursementSummaryRequestInput {
  createdAtFrom?: string | null;
  createdAtTo?: string | null;
}

/**
 * 약국 취급약품 등록 요청
 */
export interface PharmacyHandlingMedicineRegisterMutationRequestInput {
  medicineId: string;
  medicineStandardPrices: PharmacyHandlingMedicineStandardPriceRegisterMutationRequestInput[];
}

/**
 * 약국 취급약품 조회 요청
 */
export interface PharmacyHandlingMedicineRequestInput {
  medicineId: string;
}

/**
 * 약국 취급약품 규격별 가격 등록 요청
 */
export interface PharmacyHandlingMedicineStandardPriceRegisterMutationRequestInput {
  medicineStandardId: string;
  price: number;
}

/**
 * 약국 취급약품 등록/수정 요청
 */
export interface PharmacyHandlingMedicineStandardPriceUpsertMutationRequestInput {
  medicineStandardId: string;
  price: number;
}

/**
 * 약국 취급약품 규격 품절 처리
 */
export interface PharmacyHandlingMedicineStandardSoldOutMutationRequestInput {
  medicineId: string;
  medicineStandardId: string;
}

/**
 * 약국 취급약품 수정 요청
 */
export interface PharmacyHandlingMedicineUpsertMutationRequestInput {
  medicineId: string;
  medicineStandardPrices: PharmacyHandlingMedicineStandardPriceUpsertMutationRequestInput[];
}

export interface SendEmergencyMessageRequestInput {
  orderId: string;
  pharmacyPhone: string;
  reason: string;
  reasonId: string;
}

/**
 * 송장 출력에 필요한 데이터 요청
 */
export interface ShippingLabelRequestInput {
  orderNumber: string;
  shippingCompany: ShippingCompany;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
